module.exports = __webpack_public_path__ + "static/10-42cf50c0df0919a9ec89ff5e9c6f273e.jpg";